import { buildClassMap } from '../utilities/index';
import { AnimationStyles } from '../styles/index';
export var AnimationClassNames = buildClassMap(AnimationStyles);
//# sourceMappingURL=AnimationClassNames.js.map